module.exports = __webpack_public_path__ + "media/images/svg-sprite-items/payment/mastercard-a012d5b43f6a82e7ed254d183fcabd0f.svg";